import { ADD_SPARKED_PARKING_DATA } from "./sparkedParkingDataReducer"

export const addSparkedParkingData = (data) => ({
    type: ADD_SPARKED_PARKING_DATA,
    payload: data
})